import { useParams } from "react-router-dom";
import { CreateGameRuleTemplateView } from "../components/organisms/CreateGameRuleTemplateView";

export const CreateGameRuleTemplatePage = () => {
  const { templateId } = useParams<{ templateId?: string }>();
  return <CreateGameRuleTemplateView editTemplateId={templateId} />;
};
